import { Box } from "@mui/material";
import Icon from "@mui/material/Icon";

interface ForestEditIconProps {
  size?: number;
}

const ForestEditIcon = ({ size = 24 }: ForestEditIconProps) => {
  const forestSize = Math.round(size * 0.75);
  const pencilSize = Math.max(12, Math.round(size * 0.56));

  return (
    <Box
      sx={{
        position: "relative",
        width: size,
        height: size,
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          left: 1,
          top: 0,
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          width: forestSize,
          height: forestSize,
        }}
      >
        <Icon sx={{ fontSize: forestSize, color: "inherit" }}>forest</Icon>
      </Box>
      <Icon
        sx={{
          position: "absolute",
          right: -1,
          bottom: -1,
          fontSize: pencilSize,
          color: "inherit",
          textShadow: "0 0 2px rgba(0,0,0,0.35)",
        }}
      >
        edit
      </Icon>
    </Box>
  );
};

export default ForestEditIcon;
